<template>
    <div class="approve-ctrl-container">

        <p class="title">审核批注：</p>
        <div>
            <el-input  :maxlength="200" v-model="textareaValue"
              :show-word-limit="true" type="textarea" placeholder="如果需要填写批注请在此处输入"></el-input>
            <el-select style="width:100%;margin:10px 0" v-model="selectValue">
                <el-option v-for="item in textArray" :value="item" ></el-option>
            </el-select>
            <div>
                <el-button type="primary" @click="submit(1)">通过</el-button>
                <el-button @click="submit(0)">不通过</el-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            value:'',
            textareaValue:'',
            selectValue:'',
            textArray:[
                '图片不清晰',
                '定位地点错误',
                '不符合任务要求'
            ]
        }
    },
    methods:{
        submit(type){
            this.value = this.textareaValue + this.selectValue
            if(type){
                this.$confirm('是否确认审核通过?', '', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$emit('submit',this.value)
                }).catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '已取消删除'
                    // });          
                });
                
            }else{
                 this.$confirm('是否确认审核不通过?', '', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$emit('withdraw',this.value)
                }).catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '已取消删除'
                    // });          
                });
                
            }
        }
    }
}
</script>

<style>
.approve-ctrl-container{
    display: flex;
}
</style>